export default {"src":"/_next/static/media/cogwheel.73bbfb9d.gif","height":213,"width":320};